import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface WavyBadgeProps {
  children: ReactNode;
  className?: string;
  filled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

const WAVY_PATH =
  'M50 2 C58 2 62 8 70 10 C78 12 86 8 90 16 C94 24 88 30 90 38 C92 46 98 52 96 60 C94 68 86 70 82 78 C78 86 80 94 72 96 C64 98 58 92 50 92 C42 92 36 98 28 96 C20 94 22 86 18 78 C14 70 6 68 4 60 C2 52 8 46 10 38 C12 30 6 24 10 16 C14 8 22 12 30 10 C38 8 42 2 50 2 Z';

const WavyBadge = ({
  children,
  className,
  filled = true,
  size = 'md',
  onClick,
}: WavyBadgeProps) => {
  const sizeClasses = {
    sm: 'w-12 h-12 text-[10px]',
    md: 'w-16 h-16 text-xs',
    lg: 'w-20 h-20 text-sm',
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'relative inline-flex items-center justify-center font-bold text-deep-800 transition-transform active:scale-95',
        onClick && 'cursor-pointer',
        sizeClasses[size],
        className
      )}
    >
      <svg
        viewBox="0 0 100 100"
        className="absolute inset-0 w-full h-full"
        preserveAspectRatio="none"
      >
        <path
          d={WAVY_PATH}
          fill={filled ? 'hsl(var(--lime-500))' : 'hsl(var(--cream))'}
          stroke="hsl(var(--deep-800))"
          strokeWidth="2"
        />
      </svg>
      <span className="relative z-10 text-center leading-tight px-1 max-w-[85%] break-words hyphens-auto">
        {children}
      </span>
    </button>
  );
};

export default WavyBadge;
